import GrabRefreshLogo from "@assets/images/grab-refresh.png";
import { makeStyles } from "@material-ui/core/styles";
import { OrderCourierEnum } from "@saleor/motherOrders/utils/enums";
import { DeliveriesStatus } from "@saleor/types/globalTypes";
import React from "react";
export interface DeliveriesStatusCellProps {
  orderId: string | null;
  onGrabStatusRefresh?: (orderId: string) => void;
  onPandaGoStatusRefresh?: (orderId: string) => void;
  thirdPartyCourier?: string | null;
  thirdPartyLogisticStatus: DeliveriesStatus | null;
}

const useStyles = makeStyles(
  {
    buttonContainer: {
      background: "transparent",
      border: "none",
      cursor: "pointer"
    },
    cellHolder: {
      alignItems: "center",
      color: "#6DAB64",
      display: "flex",
      fontSize: "17px",
      fontWeight: 600,
      justifyContent: "center",
      padding: "5px"
    },
    cellHolderGrabUserCanceled: {
      alignItems: "center",
      color: "#EC5D77",
      display: "flex",
      fontSize: "17px",
      fontWeight: 600,
      justifyContent: "space-between",
      padding: "5px"
    },
    refreshLogo: {
      height: "20px",
      marginLeft: "15px"
    }
  },
  { name: "Order3plStatus" }
);

const generalDeliveryStatus: Partial<Record<DeliveriesStatus, string>> = {
  [DeliveriesStatus.GENERAL_ASSIGNING]: "Assigning",
  [DeliveriesStatus.GENERAL_PICKING_UP]: "Picking Up",
  [DeliveriesStatus.GENERAL_IN_DELIVERY]: "In Delivery",
  [DeliveriesStatus.GENERAL_COMPLETED]: "Completed",
  [DeliveriesStatus.GENERAL_CANCELLED]: "Cancelled",
  [DeliveriesStatus.GENERAL_USER_CANCELLED]: "User Cancelled",
  [DeliveriesStatus.GENERAL_IN_RETURN]: "In Return",
  [DeliveriesStatus.GENERAL_RETURNED]: "Returned",
  [DeliveriesStatus.GENERAL_FAILED]: "Failed",
  [DeliveriesStatus.GENERAL_DELAYED]: "Delayed"
};

const grabDeliveryStatus: Partial<Record<DeliveriesStatus, string>> = {
  [DeliveriesStatus.GRAB_QUEUEING]: "Assigning",
  [DeliveriesStatus.GRAB_ALLOCATING]: "Assigning",
  [DeliveriesStatus.GRAB_PENDING_PICKUP]: "Picking Up",
  [DeliveriesStatus.GRAB_PICKING_UP]: "Picking Up",
  [DeliveriesStatus.GRAB_IN_DELIVERY]: "In Delivery",
  [DeliveriesStatus.GRAB_PENDING_DROP_OFF]: "Pending Drop Off",
  [DeliveriesStatus.GRAB_COMPLETED]: "Completed",
  [DeliveriesStatus.GRAB_CANCELED]: "Cancelled",
  [DeliveriesStatus.GRAB_USER_CANCELED]: "User Cancelled",
  [DeliveriesStatus.GRAB_IN_RETURN]: "In Return",
  [DeliveriesStatus.GRAB_RETURNED]: "Returned",
  [DeliveriesStatus.GRAB_FAILED]: "Failed"
};

const pandagoDeliveryStatus: Partial<Record<DeliveriesStatus, string>> = {
  [DeliveriesStatus.PANDAGO_NEW]: "Assigning",
  [DeliveriesStatus.PANDAGO_RECEIVED]: "Assigning",
  [DeliveriesStatus.PANDAGO_WAITING_FOR_TRANSPORT]: "Assigning",
  [DeliveriesStatus.PANDAGO_ASSIGNED_TO_TRANSPORT]: "Assigning",
  [DeliveriesStatus.PANDAGO_COURIER_ACCEPTED_DELIVERY]: "Picking Up",
  [DeliveriesStatus.PANDAGO_NEAR_VENDOR]: "Picking Up",
  [DeliveriesStatus.PANDAGO_PICKED_UP]: "In Delivery",
  [DeliveriesStatus.PANDAGO_COURIER_LEFT_VENDOR]: "In Delivery",
  [DeliveriesStatus.PANDAGO_NEAR_CUSTOMER]: "In Delivery",
  [DeliveriesStatus.PANDAGO_DELIVERED]: "Completed",
  [DeliveriesStatus.PANDAGO_CANCELLED]: "Cancelled",
  [DeliveriesStatus.PANDAGO_USER_CANCELLED]: "User Cancelled",
  [DeliveriesStatus.PANDAGO_RETURNED_TO_VENDOR]: "Returned",
  [DeliveriesStatus.PANDAGO_DELAYED]: "Delayed"
};

const DeliveriesStatusCell: React.FC<DeliveriesStatusCellProps> = props => {
  const {
    orderId,
    onGrabStatusRefresh,
    onPandaGoStatusRefresh,
    thirdPartyLogisticStatus,
    thirdPartyCourier
  } = props;
  const classes = useStyles(props);

  const isUserCancelled = [
    DeliveriesStatus.GRAB_USER_CANCELED,
    DeliveriesStatus.PANDAGO_USER_CANCELLED,
    DeliveriesStatus.GENERAL_USER_CANCELLED
  ].includes(thirdPartyLogisticStatus);

  const current3plStatus =
    generalDeliveryStatus[thirdPartyLogisticStatus] ||
    grabDeliveryStatus[thirdPartyLogisticStatus] ||
    pandagoDeliveryStatus[thirdPartyLogisticStatus] ||
    "";

  const handleStatusRefresh = () =>
    thirdPartyCourier === OrderCourierEnum.GRAB_EXPRESS
      ? onGrabStatusRefresh(orderId)
      : onPandaGoStatusRefresh(orderId);

  const handleCellHolderStyle = () =>
    isUserCancelled ? classes.cellHolderGrabUserCanceled : classes.cellHolder;

  return (
    <span className={handleCellHolderStyle()}>
      {current3plStatus}
      {!isUserCancelled && (
        <button
          className={classes.buttonContainer}
          onClick={handleStatusRefresh}
        >
          <img className={classes.refreshLogo} src={GrabRefreshLogo} alt="" />
        </button>
      )}
    </span>
  );
};

export default DeliveriesStatusCell;
